/**
 * @generated SignedSource<<0e39bd4fcc50a14c02858c2dd6f59efc>>
 * @relayHash f098bfefab69014f9a90b0b0339a4e37
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5195e72d403695f3ff11ad63f280922367586e7f9ba8b44b557f5ce82be03514

import type { ConcreteRequest } from 'relay-runtime';
export type useContentContributorsDetailsPanelContentCollaboratorsQuery$variables = {
  cloudId: string;
  first: number;
  id: string;
};
export type useContentContributorsDetailsPanelContentCollaboratorsQuery$data = {
  readonly confluence_contentCollaborators: {
    readonly nodes: ReadonlyArray<{
      readonly agent: {
        readonly accountId: string;
        readonly displayName: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
      } | null;
      readonly person: {
        readonly accountId?: string | null;
        readonly displayName: string | null;
        readonly profilePicture: {
          readonly path: string;
        } | null;
        readonly type: string | null;
      };
    } | null> | null;
  } | null;
};
export type useContentContributorsDetailsPanelContentCollaboratorsQuery = {
  response: useContentContributorsDetailsPanelContentCollaboratorsQuery$data;
  variables: useContentContributorsDetailsPanelContentCollaboratorsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "type"
},
v5 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v6 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/)
  ],
  "type": "KnownUser"
},
v9 = {
  "concreteType": "ConfluenceAgent",
  "kind": "LinkedField",
  "name": "agent",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v7/*: any*/),
    (v6/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useContentContributorsDetailsPanelContentCollaboratorsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "ConfluenceCollaboratorConnection",
        "kind": "LinkedField",
        "name": "confluence_contentCollaborators",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceCollaborator",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/)
                ]
              },
              (v9/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useContentContributorsDetailsPanelContentCollaboratorsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "ConfluenceCollaboratorConnection",
        "kind": "LinkedField",
        "name": "confluence_contentCollaborators",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceCollaborator",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/)
                ]
              },
              (v9/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f098bfefab69014f9a90b0b0339a4e37",
    "id": "5195e72d403695f3ff11ad63f280922367586e7f9ba8b44b557f5ce82be03514",
    "metadata": {},
    "name": "useContentContributorsDetailsPanelContentCollaboratorsQuery",
    "operationKind": "query",
    "text": "query useContentContributorsDetailsPanelContentCollaboratorsQuery($cloudId:ID!,$id:ID!,$first:Int!){confluence_contentCollaborators(cloudId:$cloudId,id:$id,first:$first){nodes{person{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}},agent{displayName,accountId,profilePicture{path}}}}}"
  }
};
})();

(node as any).hash = "feab7438e52371c4bf16fc7ca78b68fd";

export default node;
